
import Box from "@mui/material/Box";

const DigitalDisplay = ({ number, hidden }) => {
  var numberString;
  if (!isNaN(number)) {
    numberString = number.toString().padStart(3, "0");
  } else {
    numberString = "000";
  }
  var display = [];
  for (var i = 0; i < numberString.length; i++) {
    display.push(
      <Box
        key={"img" + i}
        sx={{
          width: "1.1rem",
          height: "2rem",
          padding: "0.2rem",
          display: "inline-block",
        }}
      >
        <img
          style={{ width: "0.95rem" }}
          src={require("Components/Game/Digits/" + numberString.substring(i, i + 1) + ".png")}
          alt=""
        />
      </Box>
    );
  }
  return (
    <Box
      sx={{
        width: "3.7rem",
        height: "2.2rem",
        backgroundColor: "black",
        border: "1px inset #788088",
        display: hidden ? "none" : "inline-block"
      }}
    >
      {display}
    </Box>
  );
};

export default DigitalDisplay;
